import { StyledButton } from "components/button.styles";
import Panel from "components/layout/panel";
import View from "components/layout/view";
import Title from "components/title";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Colors } from "theme/colors";

interface TransitionProps {
  $transition: boolean;
}

export const StyledView = styled(View)<TransitionProps>`
  &::before {
    content: "";
    z-index: 0;
    transition: opacity 0.5s;
    background-image: url("/assets/triangles.svg");
    background-size: cover;
    background-position: 50% 50%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 1;

    ${(props) =>
      props.$transition &&
      css`
        opacity: 0;
      `}
  }
`;

export const StyledContainer = styled.div<TransitionProps>`
  display: flex;
  flex: 1;
  z-index: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${StyledButton} {
    width: 100%;
  }

  transition: opacity 0.5s;
  opacity: 1;
  ${(props) =>
    props.$transition &&
    css`
      opacity: 0;
    `}
`;

interface PanelProps {
  $wide?: boolean;
}
export const StyledPanel = styled(Panel)<PanelProps>`
  max-width: 30rem;
  ${(props) =>
    props.$wide &&
    css`
      max-width: 60rem;
    `}
  padding: 3.125rem;
`;

export const StyledLogo = styled.img`
  max-width: 30rem;
  margin-bottom: 2rem;
`;

export const StyledOrgName = styled(Title)`
  color: ${Colors.WHITE};
  margin-bottom: 1.125rem;
`;

export const StyledTitle = styled(Title)`
  font-size: 2.125rem;
  color: ${Colors.WHITE};
  margin-bottom: 1.125rem;
`;

export const StyledFooter = styled.div`
  margin-top: 5rem;
  color: ${Colors.WHITE};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledCopyright = styled.div``;

export const StyledLocaleSwitcher = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 1.75rem;
`;

export const StyledPrivacyPolicy = styled.div`
  cursor: pointer;
`;

interface LocaleProps {
  $active: boolean;
}

export const StyledLocale = styled.div<LocaleProps>`
  color: ${Colors.WHITE};
  cursor: pointer;

  ${(props) =>
    props.$active &&
    css`
      text-decoration: underline;
      pointer: default;
      pointer-events: none;
    `}
`;

export const StyledGuide = styled.div`
  line-height: 1.5;
`;

export const StyledLinks = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 1.75rem;
  color: ${Colors.WHITE};
`;

export const StyledAccessibility = styled.div`
  cursor: pointer;
`;
